export function isStripeRedirect() {
  if (typeof window === 'undefined') {
    return false
  }

  return new URLSearchParams(window.location.search).has('redirect_status')
}